<template>
    <div class="flex-1 text-gray-800">
        <div class="text-xxs font-semibold">{{ ratingLabel }}</div>
        <div class="flex items-center flex-grow">
            <div class="w-full h-sm bg-gray-200 shadow-inner rounded-full mr-md">
                <div
                    class="h-full bg-green-500 rounded-full"
                    :style="{ 'width': barPercent }"
                />
            </div>
            <div class="font-bold text-sm">{{ subRatingAverage ? formatNumber(subRatingAverage) : '' }}</div>

            <div v-if="$slots.default" class="flex-none">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            ratingLabel: {
                type: String,
                required: true,
            },
            subRatingAverage: {
                type: Number,
                default: null,
            },
        },

        computed: {
            barPercent() {
                return Math.round((this.subRatingAverage / 5) * 100) + '%';
            },
        },
    };
</script>
